import * as actions from "./actionsType";

const initialData = {
  loading: false,
  saveLoading: false,
  planIndividual: [],
  planIndividualError: "",
  formError: "",
};

export default function PlanIndividualReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PLAN_INDIVIDUAL:      
      return { ...state, loading: action.payload };

    case actions.SAVE_LOADING_PLAN_INDIVIDUAL:
      return { ...state, saveLoading: action.payload };

    case actions.GET_PLAN_INDIVIDUAL:
      return {
        ...state,
        planIndividual: action.payload.planIndividual
      };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.PLAN_INDIVIDUAL_FAIL:
      return { ...state, planIndividualError: action.payload };

    default:
      return state;
  }
}
